import { differenceInYears } from 'date-fns';

import type { Customer, User } from '@barboxx/models/types';

export function getCustomerInitials(customer: Customer.Auth) {
    if (customer?.displayName) {
        return customer?.displayName
            .split(' ')
            .map((segment: string) => segment.substring(0, 1))
            .slice(0, 2)
            .join('');
    } else {
        return getInitials(customer);
    }
}

export function getInitials(user: Customer | User, singleInitial?: boolean) {
    const firstLetter = user?.firstName[0]?.toUpperCase() ?? '';
    const lastLetter = user?.lastName[0]?.toUpperCase() ?? '';
    return singleInitial
        ? firstLetter || lastLetter
        : `${firstLetter}${lastLetter}`;
}

export function getCustomerFullName(customer: Customer) {
    return `${customer.firstName} ${customer.lastName}`;
}

export function checkAgeOver(dob: string, age: number) {
    const today = new Date();
    const ageInYears = differenceInYears(today, dob);

    return ageInYears >= age;
}
